module.exports = "/_next/static/resources/inter-italic.var-88f223908b7e6c8e59abd25700f9c664.woff2";